'use strict';

function Building (object, dictionary) {
  /** @var Type|null Тип/серия здания */
  this.type = dictionary.getBuildingType(object.get('buildingTypeId')) || null;

  /** @var Material|\null Материал здания */
  this.material = dictionary.getMaterial(object.get('materialId')) || null;

  /** @var Heating|null Тип отопления */
  this.heatingType = dictionary.getHeating(object.get('heatingId')) || null;

  /** @var bool|null Есть отопление или нет (гаражи) */
  this.heating = object.get('hasHeating');

  /** @var bool|null Является ли здание новостройкой */
  this.newBuilding = object.get('isNewBuilding');

  /** @var int|null Год постройки */
  this.buildYear = object.get('builtYear');

  /** @var bool|null Сдан или нет */
  this.isBuilt = object.get('isBuilt');

  /** @var int|null Квартал сдачи */
  this.deadlineQuarter = object.get('deadlineQuarter');

  /** @var int|null Год сдачи */
  this.deadlineYear = object.get('deadlineYear');

  /** @var int|null Количество этажей над уровнем земли */
  this.floorsNumberAboveGround = object.get('floorTotal', null) || null;

  /** @var bool|null Строение первой линии */
  this.firstLine = object.get('isFirstLine', null);

  const size = object.get('size');
  /** @var Distance|null Ширина */
  this.width = (size && size.get('width')) || null;
  /** @var Distance|null Высота */
  this.height = (size && size.get('height')) || null;
  /** @var Distance|null Длинна */
  this.length = (size && size.get('length')) || null;

  /** @var bool|null Отдельно стоящее */
  this.detached = object.get('detachedBuilding', null);

  /** @var bool|null Наличие мусоропровода */
  this.rubbishChute = object.get('hasRubbishChute', null);

  /** @var bool|null Наличие лифта */
  this.elevator = object.get('hasElevator', null);

  /** @var bool|null Наличие домофона */
  this.intercom = object.get('hasIntercom', null);

  /** @var bool|null Наличие электричества */
  this.electricity = object.get('hasElectricity', null);

  /** @var bool|null Наличие воды */
  this.water = object.get('hasWater', null);

  /** @var bool|null Наличие канализации */
  this.canalization = object.get('hasCanalization', null);

  /** @var bool|null Наличие газоснабжения */
  this.gas = object.get('hasGas', null);

  /** @var bool|null Наличие погреба */
  this.cellar = object.get('hasCellar', null);

  /** @var bool|null Наличие ремонтной ямы */
  this.repairPit = object.get('hasRepairPit', null);
}

Building.prototype.getType = function () {
  return this.type;
};

Building.prototype.getMaterial = function () {
  return this.material;
};

Building.prototype.getHeating = function () {
  return this.heatingType;
};

Building.prototype.hasElevator = function () {
  return this.elevator;
};

Building.prototype.hasGas = function () {
  return this.gas;
};

Building.prototype.hasIntercom = function () {
  return this.intercom;
};

Building.prototype.hasRubbishChute = function () {
  return this.rubbishChute;
};

Building.prototype.hasHeating = function () {
  return this.heating;
};
Building.prototype.getLabelHeating = function () {
  return this.hasHeating() ? 'отопление' : '';
};

Building.prototype.hasRepairPit = function () {
  return this.repairPit;
};
Building.prototype.getLabelRepairPit = function () {
  return this.hasRepairPit() ? 'смотровая яма' : '';
};

Building.prototype.hasCellar = function () {
  return this.cellar;
};
Building.prototype.getLabelCellar = function () {
  return this.hasCellar() ? 'погреб' : '';
};

Building.prototype.hasElectricity = function () {
  return this.electricity;
};
Building.prototype.getLabelElectricity = function () {
  return this.hasElectricity() ? 'эл.снабжение' : '';
};

Building.prototype.hasWater = function () {
  return this.water;
};
Building.prototype.getLabelWater = function () {
  return this.hasWater() ? 'водоснабжение' : '';
};

Building.prototype.hasCanalization = function () {
  return this.canalization;
};
Building.prototype.getLabelCanalization = function () {
  return this.hasCanalization() ? 'канализация' : '';
};

Building.prototype.getSizeLabel = function () {
  if (this.width || this.height || this.length) {
    return (this.width || '-') + '\u00A0x\u00A0' + (this.height || '-') + '\u00A0x\u00A0' + (this.length || '-');
  }

  return '';
};

Building.prototype.isNewBuilding = function () {
  return this.newBuilding;
};
Building.prototype.getLabelNewBuilding = function (isUpperCase = false) {
  return this.isNewBuilding() ? (isUpperCase ? 'Н' : 'н') + 'овостройка' : '';
};

Building.prototype.getBuildYear = function () {
  return this.buildYear;
};

Building.prototype.getIsBuild = function () {
  return this.isBuilt;
};

Building.prototype.getDeadlineQuarter = function () {
  return this.deadlineQuarter;
};

Building.prototype.getDeadlineYear = function () {
  return this.deadlineYear;
};

/**
 * Дата сдачи или постройки дома
 */
Building.prototype.getDeliveryDateLabel = function () {
  const deadYear = this.getDeadlineYear();
  const deadQuarter = this.getDeadlineQuarter();
  const buildYear = this.getBuildYear();

  if (deadYear) {
    return 'сдача\u00A0' + [
        (deadQuarter ? deadQuarter + '\u00A0кв.' : null),
        (deadYear + '\u00A0г.')
    ].filter(Boolean).join('\u00A0');
  }

  return buildYear ? ('построен\u00A0' + buildYear + 'г.') : (this.getIsBuild() && this.isNewBuilding() ? 'дом сдан' : '');
};

/**
 * Дата сдачи или постройки дома
 */
Building.prototype.getDeliveryDateShortLabel = function () {
  const deadYear = this.getDeadlineYear();
  const deadQuarter = this.getDeadlineQuarter();
  const buildYear = this.getBuildYear();

  if (deadYear) {
    return [
        (deadQuarter ? deadQuarter + '\u00A0-й квартал' : null),
        (deadYear + '\u00A0года')
    ].filter(Boolean).join('\u00A0');
  }

  return buildYear || (this.getIsBuild() && this.isNewBuilding() ? 'дом сдан' : '-');
};

Building.prototype.getFloorsNumberAboveGround = function () {
  return this.floorsNumberAboveGround;
};

/**
 * Первая линия
 * @returns {*|bool|null}
 */
Building.prototype.isFirstLine = function () {
  return this.firstLine;
};
Building.prototype.getLabelFirstLine = function () {
  return this.isFirstLine() ? 'первая линия' : '';
};

Building.prototype.isDetached = function () {
  return this.detached;
};
Building.prototype.getLabelDetached = function () {
  return this.isDetached() ? 'отдельно стоящее здание' : '';
};

export default Building;



// WEBPACK FOOTER //
// ./src/classes/announcement/property/building.js